import { createActions, createReducer } from 'reduxsauce'

import InformacoesInstitucionaisService from '_/servicos/InformacoesInstitucionaisService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaInformacaoInicio: [],
    buscaInformacaoSucesso: ['informacoesInstitucionais'],
    buscaInformacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaInformacoesInstitucionais = () => {
    return dispatch => {
        dispatch(Creators.buscaInformacaoInicio())

        let serv = new InformacoesInstitucionaisService()

        return serv
            .getInformacoes()
            .then(response => dispatch(Creators.buscaInformacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaInformacaoErro(error)))
    }
}

const buscaInformacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaInformacaoSucesso = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaInformacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.informacoesInstitucionais, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_INFORMACAO_INICIO]: buscaInformacaoInicio,
    [Types.BUSCA_INFORMACAO_ERRO]: buscaInformacaoSucesso,
    [Types.BUSCA_INFORMACAO_SUCESSO]: buscaInformacaoErro,
})
